import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { getIconSrcUrl } from '../..';
import { pxToRem } from '../../utils/size-to-rem';
import { Click } from '../click';
import { commonStyles, iconButtonStyle } from './IconButton.styles';
import { INTENTS, NAMES, VARIANTS } from './types';
export const IconButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    iconName,
    disabled = false,
    variant = 'transparent',
    intent = 'primary',
    bleed = variant === 'transparent',
    ...rest
  } = _ref;
  const {
    theme,
    css
  } = useFela();
  const size = 40;
  const iconSize = size === 40 ? 24 : 16;
  const color = getIconColor({
    variant,
    isHovered: false,
    intent
  });
  const defaultIcon = getIconSrcUrl({
    color,
    name: iconName,
    size: iconSize,
    theme
  });
  const hoverIcon = getIconSrcUrl({
    color: getIconColor({
      variant,
      isHovered: true,
      intent
    }),
    name: iconName,
    size: iconSize,
    theme
  });
  return /*#__PURE__*/React.createElement(Click, _extends({
    ref: ref
  }, disabled && {
    'aria-disabled': disabled,
    disabled
  }, {
    extend: [commonStyles({
      size,
      bleed
    }), iconButtonStyle(variant, intent), {
      ':hover:not([aria-disabled=true])': {
        '> img': {
          paddingLeft: pxToRem(iconSize),
          backgroundImage: `url(${hoverIcon})`
        }
      }
    }]
  }, rest), /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: defaultIcon,
    className: css({
      backgroundPosition: 'center',
      backgroundSize: `${pxToRem(iconSize)} ${pxToRem(iconSize)}`,
      boxSizing: 'border-box',
      height: pxToRem(iconSize),
      width: pxToRem(iconSize)
    }),
    height: iconSize,
    width: iconSize
  }));
});

const getIconColor = _ref2 => {
  let {
    intent,
    isHovered,
    variant
  } = _ref2;

  if (variant === 'media') {
    if (intent === 'primary' && isHovered) return 'primary';
    return 'inverted';
  }

  if (variant === 'outline') {
    if (isHovered) return 'inverted';
  }

  if (intent === 'destructive' && !isHovered) return 'alert';
  return 'primary';
};

IconButton.propTypes = {
  'aria-label': PropTypes.string,
  bleed: PropTypes.bool,
  disabled: PropTypes.bool,
  iconName: PropTypes.oneOf(NAMES).isRequired,
  intent: PropTypes.oneOf(INTENTS),
  variant: PropTypes.oneOf(VARIANTS)
};
IconButton.displayName = 'IconButton';